import { formatCurrency } from "utils/formatNumber";

const CustomChartTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const [month, year] = label.split("/");
    const fullYear = `20${year}`;

    return (
      <div className="custom-tooltip bg-white p-2 border rounded-lg shadow-sm ">
        <p className="label text-gray-400">
          {`${month}/${fullYear}`} -{" "}
          <span className="text-primary">
            {formatCurrency(payload[0].value, "EUR")}
          </span>
        </p>
      </div>
    );
  }
  return null;
};

export default CustomChartTooltip;
